import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { API, api, formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

export const EnterDialog = ({ open, onClose, challengeId, current, onDone }) => {
  const { t } = useI18n();
  const [clips, setClips] = useState(null);
  const [pick, setPick] = useState(current);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open) return;
    setPick(current);
    api.get("/stats/shares").then((r) => setClips(r.data.clips.filter((c) => c.shared))).catch(() => setClips([]));
  }, [open, current]);
  const submit = async () => {
    setBusy(true);
    try { await api.post(`/challenges/${challengeId}/enter`, { clip_id: pick }); toast.success(t("ch.entered")); onDone(); onClose(); }
    catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="challenge-enter-dialog" className="bg-[#0a0d1a] border border-[#ff4d6d]/40 max-w-xl max-h-[85vh] overflow-y-auto">
        <DialogTitle className="font-display text-2xl text-white">{t("ch.pick_title")}</DialogTitle>
        <DialogDescription className="text-sm text-slate-400">{t("ch.pick_desc")}</DialogDescription>
        {clips && !clips.length && <p className="text-sm text-slate-400 py-6" data-testid="challenge-pick-empty">{t("ch.pick_empty")}</p>}
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mt-2">
          {(clips || []).map((c) => (
            <button key={c.id} type="button" onClick={() => setPick(c.id)} data-testid={`challenge-pick-${c.id}`}
              className={`relative rounded-xl overflow-hidden border text-left transition-colors ${pick === c.id ? "border-[#ff4d6d] shadow-[0_0_24px_-6px_rgba(255,77,109,0.8)]" : "border-white/10 hover:border-white/30"}`}>
              <img src={`${API}/s/${c.share_id}/thumb.jpg`} alt="" className="w-full aspect-video object-cover bg-black" />
              <div className="p-2 text-xs text-white truncate">{c.title}</div>
              {pick === c.id && <span className="absolute top-2 right-2 w-6 h-6 rounded-full bg-[#ff4d6d] grid place-items-center"><Check className="w-4 h-4 text-white" /></span>}
            </button>
          ))}
        </div>
        <button disabled={!pick || busy || pick === current} onClick={submit} data-testid="challenge-pick-confirm"
          className="cx-btn rounded-full px-6 py-3 text-sm font-semibold mt-4 disabled:opacity-40">{t("ch.pick_confirm")}</button>
      </DialogContent>
    </Dialog>
  );
};
